'use strict';

var React = require('react/addons');
var Reflux = require('reflux');

/* Stores */
var ModuleInspectorStore = require('stores/module-inspector');
var DatasourceStore = require('stores/datasource');
var LanguageStore = require('stores/language');

/* Components */
var TitledGroup = require('components/ui/titled-group');

var ModuleInspectorPropertyTypeDatasource = React.createClass({
  displayName: 'ModuleInspectorPropertyTypeDatasource',

  mixins: [Reflux.connect(DatasourceStore, 'datasources')],

  getInitialState: function getInitialState() {
    return {
      focus: false
    };
  },

  render: function render() {
    var cx = React.addons.classSet;

    var component = this;
    var props = component.props;
    var state = component.state;

    /* Translations */
    var noOptionTranslation = LanguageStore.translate('inspector_datasource_none_select');
    var titleTranslation = ModuleInspectorStore.translate(props.groupName + '_' + props.name);

    var projectDatasources = state.datasources.filter(function (datasource) {
      return datasource.projects.some(function (assignedProject) {
        return assignedProject.projectId === props.projectId;
      });
    });

    var optionNodes = projectDatasources.map(function (datasource) {
      return React.createElement(
        'option',
        { key: datasource.id, value: datasource.id },
        datasource.name
      );
    });

    var classes = {};
    classes['select'] = true;
    classes['focus'] = state.focus;

    return React.createElement(
      TitledGroup,
      { className: cx(classes), title: titleTranslation },
      React.createElement(
        'select',
        {
          ref: 'select',
          disabled: props.disabled,
          value: props.value || '',
          onChange: component.onChange,
          onFocus: component.onFocus,
          onBlur: component.onBlur },
        React.createElement(
          'option',
          { key: '', 'default': true, value: '' },
          noOptionTranslation
        ),
        optionNodes
      )
    );
  },

  onChange: function onChange(evt) {
    var component = this;
    var props = component.props;
    var value = component.refs.select.getDOMNode().value;

    if (props.onChange) {
      /* Send original value and new value */
      props.onChange(props.value, value);
    }
  },

  onFocus: function onFocus() {
    this.setState({ focus: true });
  },

  onBlur: function onBlur() {
    this.setState({ focus: false });
  }
});

module.exports = ModuleInspectorPropertyTypeDatasource;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/project/playground/module/inspector/type/datasource.js
 **/